import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { isLogin, parseJwt } from '../utils/session';
import PrivateLayout from '../components/Layout/PrivateLayout';
import PublicLayout from '../components/Layout/PublicLayout';
import {
  canCommunicationsAccessPath,
  isCommunicationsRole,
} from '../utils/roleAccess';

const RouteWrapper = ({
  component: Component,
  path,
  restricted = false,
  isPublic = false,
}) => {
  const location = useLocation();
  const isRestrictionDeepLink =
    location.pathname === '/usuarios/editar' &&
    new URLSearchParams(location.search).get('tab') === 'restrictions';
  // Window's title
  const token = window.sessionStorage.getItem('converge.token.private');
  const tokenData = parseJwt(token);
  const isCommunications = isCommunicationsRole(tokenData);
  const isAllowedForCommunications =
    !isCommunications || canCommunicationsAccessPath(path);

  return isPublic ? (
    isLogin() && restricted ? (
      <Redirect to="/usuarios" />
    ) : (
      <Route
        path={path}
        render={(props) => (
          <PublicLayout {...props}>
            <Component {...props} />
          </PublicLayout>
        )}
      />
    )
  ) : isLogin() ? (
    isAllowedForCommunications ? (
      <Route
        path={path}
        render={(props) => (
          <PrivateLayout {...props}>
            <Component {...props} />
          </PrivateLayout>
        )}
      />
    ) : (
      <Redirect to="/dashboard" />
    )
  ) : (
    <Redirect
      to={{
        pathname: '/',
        state: isRestrictionDeepLink
          ? { from: `${location.pathname}${location.search}` }
          : undefined,
      }}
    />
  );
};

RouteWrapper.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  restricted: PropTypes.bool,
  isPublic: PropTypes.bool,
};

export default RouteWrapper;
